import React, { useState, useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { CardText, CardBody } from "reactstrap";
import { BarChart } from "components/Charts/components";
import axios from "utils/api";

const MonthlyVolumeTransactions = () => {
  const authSession = JSON.parse(localStorage.getItem('auth'));
  const [data, setData] = useState({});
  var sampleData = { labels: [], datasets: [] };
  
  useEffect(() => {
    let mounted = true;

    if (mounted) {
      axios.get(`dashboard/getmonthlytransactionvolume?accountId=${authSession?.merchantGroupCode}&portaluserid=${authSession?.portalUserId}`)
        .then(response => {
          for (const initialValue of Object.values(response.data.transactions)) {
            var groupData = initialValue.groups.filter(x => x.length !== 0);
    
            for (var o = 0; o < groupData.length; o++) {
              if (groupData.length !== 0 && !sampleData.datasets.some(x => x.label === groupData[o].group)) {
                sampleData.datasets.push({
                  label: groupData[o].group, 
                  backgroundColor: setBackgroundColor(groupData[o].group),
                  borderColor: 'rgba(0,0,0,0.4)',
                  borderWidth: 1,
                  data: []
                })
              }
            }
          }
    
          for (const initialValue of Object.values(response.data.transactions)) {
            sampleData.labels.push(`${initialValue.week} (${initialValue.dates})`);

            if (initialValue.groups.length !== 0) {
              var tempGroupArray = [];
    
              for (var j = 0; j < initialValue.groups.length; j++) {
                tempGroupArray.push(initialValue.groups[j].group);
                sampleData.datasets.find(x => x.label === initialValue.groups[j].group).data.push(initialValue.groups[j].amount);
              }
            
              for(var k = 0; k < sampleData.datasets.length; k++) {
                if (!tempGroupArray.includes(sampleData.datasets[k].label)) {
                  sampleData.datasets[k].data.push(0);
                }
              }
            }
            else {
              for (var m = 0; m < sampleData.datasets.length; m++) {
                sampleData.datasets[m].data.push(0);
              }
            }
          }

          setData(sampleData);
        }).catch(() => { 
          console.log('There was a problem fetching monthly transaction volume. Please try again later.');
        });
    }

    return () => {
      setData({});

      mounted = false;
    };
  }, []);

  const setBackgroundColor = (group) => {
    let rgbColor = 'rgba(119,136,153)';

    if (group === 'Success')
      rgbColor = 'rgba(0,128,0)';
    else if (group === 'Failed')
      rgbColor = 'rgba(255,140,0)';
    else if (group === 'InProcess') 
      rgbColor = 'rgba(0,0,139)';
    else
      rgbColor = 'rgba(255,255,0)';
    
    return rgbColor;
  }

  return (
      <CardBody>
        <CardText>Showing monthly transaction volume for past 4 weeks.</CardText>
        <CardText>
          <small className="text-muted">Last updated 3 mins ago</small>
        </CardText>
        <PerfectScrollbar>
          <div>
            <BarChart data={data}
            />
          </div>
        </PerfectScrollbar>
      </CardBody>
   // </Card>
  );
};

export default MonthlyVolumeTransactions;